// extracted by mini-css-extract-plugin
module.exports = {"rightSide":"Batches_rightSide__k_jHZ","addBatch":"Batches_addBatch__3MN-U","mainbar":"Batches_mainbar__1pKuJ"};